import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Jalali } from 'jalali-ts';
import { finalize } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { IC_Dashboard, IC_DashboardAction, IC_Template } from 'src/app/Interface/IC_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';
import { ICService } from 'src/app/Service/IC/IC.service';

@Component({ selector: 'app-ic-dashboard', templateUrl: './ICDashboard.component.html', styleUrls: ['./ICDashboard.component.css'] })
export class ICDashboardComponent implements OnInit {
  readonly scopeNotice = 'شاخص‌های اجرا و سررسید تابع فیلتر هستند؛ تجهیزات بدون تخصیص، آمار کل تجهیزات فعال است.';
  data?: IC_Dashboard;
  groups: General_Interface[] = [];
  templates: IC_Template[] = [];
  filters: FormGroup = this.fb.group({ groupId: [0], equipmentKeyword: [''], templateId: [0], window: ['all'] });
  loading = false;
  error = false;
  executingId?: number;

  constructor(private fb: FormBuilder, private service: ICService, private groupsService: DeviceGroupService,
    private router: Router, private alert: AlertifyService) { }

  ngOnInit(): void {
    this.groupsService.GetDeviceGroup(0).subscribe({ next: rows => this.groups = rows || [], error: () => this.groups = [] });
    this.service.getTemplates(undefined, true).subscribe({ next: rows => this.templates = rows || [], error: () => this.templates = [] });
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = false;
    const value = this.filters.getRawValue();
    this.service.getDashboard({ groupId: Number(value.groupId) || undefined,
      equipmentKeyword: String(value.equipmentKeyword || '').trim() || undefined,
      templateId: Number(value.templateId) || undefined,
      window: value.window === 'all' ? undefined : value.window })
      .pipe(finalize(() => this.loading = false)).subscribe({
        next: result => this.data = result,
        error: () => { this.error = true; }
      });
  }

  clear(): void {
    this.filters.reset({ groupId: 0, equipmentKeyword: '', templateId: 0, window: 'all' });
    this.load();
  }

  due(window: 'today' | 'overdue' | 'upcoming' | 'next30' = 'today'): void {
    const values = this.filters.getRawValue();
    const queryParams: any = { window };
    if (Number(values.groupId)) queryParams.groupId = Number(values.groupId);
    if (Number(values.templateId)) queryParams.templateId = Number(values.templateId);
    if (String(values.equipmentKeyword || '').trim()) queryParams.equipmentKeyword = String(values.equipmentKeyword).trim();
    if (values.window && values.window !== 'all') queryParams.scopeWindow = values.window;
    if (window === 'upcoming' || window === 'next30') queryParams.excludeBlocked = true;
    this.router.navigate(['/ic/due'], { queryParams });
  }
  history(result?: string, executionId?: number): void {
    const value = this.filters.value;
    const queryParams: any = { result: result || undefined, executionId: executionId || undefined };
    if (Number(value.groupId) > 0) queryParams.groupId = Number(value.groupId);
    if (Number(value.templateId) > 0) queryParams.templateId = Number(value.templateId);
    if (String(value.equipmentKeyword || '').trim()) queryParams.dashboardEquipmentKeyword = String(value.equipmentKeyword).trim();
    if (value.window && value.window !== 'all') queryParams.scopeWindow = value.window;
    this.router.navigate(['/ic/history'], { queryParams });
  }
  assignment(): void { this.router.navigate(['/ic/assignment/add']); }

  act(row: IC_DashboardAction): void {
    if ((row.kind === 'OVERDUE' || row.kind === 'DUE') && row.assignmentItemId) {
      if (this.executingId) return;
      this.executingId = row.assignmentItemId;
      this.service.createExecution({ iC_Assignment_Item_ID: row.assignmentItemId, execution_Source: 'SCHEDULED' })
        .pipe(finalize(() => this.executingId = undefined)).subscribe({
          next: result => this.router.navigate(['/ic/execution/add', result.id]),
          error: error => this.alert.ErrorMessage(error?.error?.message || 'شروع اجرا ناموفق بود.')
        });
    } else if (row.kind === 'UNDER_REVIEW' && row.executionId) {
      this.router.navigate(['/ic/execution/add', row.executionId]);
    } else if (row.executionId) {
      this.history(undefined, row.executionId);
    }
  }

  actionTitle(kind: string): string {
    return ({ OVERDUE: 'گذشته از سررسید', FAIL: 'ناموفق', UNDER_REVIEW: 'در انتظار بررسی',
      DUE: 'موعد امروز' } as Record<string, string>)[kind] || kind;
  }
  resultTitle(result?: string | null): string {
    return ({ PASS: 'موفق', FAIL: 'ناموفق', UNDER_REVIEW: 'در انتظار بررسی',
      IN_PROGRESS: 'در حال اجرا', COMPLETED: 'تکمیل‌شده', APPROVED: 'تأییدشده' } as Record<string, string>)[result || ''] || result || '-';
  }
  persianDate(value?: string | null, withTime = false): string {
    if (!value) return '-';
    try { return Jalali.gregorian(value).format(withTime ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD'); }
    catch { return '-'; }
  }
  monthTitle(year: number, month: number): string {
    return `${year}/${String(month).padStart(2, '0')}`;
  }
  chartWidth(value: number, max: number): number { return max ? Math.max(2, value * 100 / max) : 0; }
  get trendMax(): number {
    return Math.max(1, ...(this.data?.monthlyTrend || []).map(x => x.passed + x.failed + x.underReview));
  }
  get dueMax(): number {
    if (!this.data) return 1;
    const due = this.data.dueOverview || { overdue: this.data.overdue, today: this.data.dueToday,
      next7: this.data.dueNext7Days, next30: this.data.dueNext30Days };
    return Math.max(1, due.overdue, due.today, due.next7, due.next30);
  }
}
